import { FamilyUnit } from '@zorro/clients';
import { employeeFamilyUnitLabelConfig } from '@zorro/types';

// TODO: FamilyUnit and PartOfCoverage basically do the same, merge them into one
export const familyUnitToStringMap: Record<FamilyUnit, string> = {
  [FamilyUnit.EMPLOYEE_ONLY]: employeeFamilyUnitLabelConfig.EMPLOYEE_ONLY,
  [FamilyUnit.EMPLOYEE_SPOUSE]: employeeFamilyUnitLabelConfig.EMPLOYEE_SPOUSE,
  [FamilyUnit.EMPLOYEE_CHILD]: employeeFamilyUnitLabelConfig.EMPLOYEE_CHILD,
  [FamilyUnit.FAMILY]: employeeFamilyUnitLabelConfig.FAMILY,
};

export function getFamilyMembersToInclude(familyUnit: string): {
  includeEmployee: boolean;
  includeSpouse: boolean;
  includeDependents: boolean;
} {
  switch (familyUnit) {
    case FamilyUnit.EMPLOYEE_ONLY:
      return {
        includeEmployee: true,
        includeSpouse: false,
        includeDependents: false,
      };
    case FamilyUnit.EMPLOYEE_SPOUSE:
      return {
        includeEmployee: true,
        includeSpouse: true,
        includeDependents: false,
      };
    case FamilyUnit.EMPLOYEE_CHILD:
      return {
        includeEmployee: true,
        includeSpouse: false,
        includeDependents: true,
      };
    case FamilyUnit.FAMILY:
    default:
      return {
        includeEmployee: true,
        includeSpouse: true,
        includeDependents: true,
      };
  }
}
